import React from "react";
import { Icon } from "antd";
import styles from "./index.module.scss";

interface HeaderProps {
    onCancel?: (evt: any) => void;
}

export default function Header({ onCancel }: HeaderProps) {
    return (
        <div className={styles.root}>
            <h1 className={styles.title}>预览</h1>

            <div className={styles.buttons}>
                <button className={styles.close} onClick={onCancel}>
                    <Icon type="close" />
                </button>
            </div>
        </div>
    );
}
